/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CustomField
 */
export interface CustomField {
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    readonly id?: number;
    /**
     * 
     * @type {Array<{ [key: string]: string | undefined; }>}
     * @memberof CustomField
     */
    labels: Array<{ [key: string]: string | undefined; }>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CustomField
     */
    options: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    order?: number;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    useForUploads?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    requireToUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    nonUserEditable?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    validation?: CustomFieldValidationEnum;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    regex?: string | null;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    rangeMin?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    rangeMax?: number | null;
    /**
     * 
     * @type {number}
     * @memberof CustomField
     */
    numberOfDigits?: number | null;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    metadataPrefill?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    highlightExpiration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CustomField
     */
    multipleResponse?: boolean;
    /**
     * 
     * @type {string}
     * @memberof CustomField
     */
    helpText?: string | null;
}

/**
* @export
* @enum {string}
*/
export enum CustomFieldValidationEnum {
    NumberOfDigits = 'number_of_digits',
    Regex = 'regex',
    Range = 'range'
}

export function CustomFieldFromJSON(json: any): CustomField {
    return CustomFieldFromJSONTyped(json, false);
}

export function CustomFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomField {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'labels': json['labels'],
        'options': json['options'],
        'name': json['name'],
        'order': !exists(json, 'order') ? undefined : json['order'],
        'type': json['type'],
        'useForUploads': !exists(json, 'use_for_uploads') ? undefined : json['use_for_uploads'],
        'requireToUpload': !exists(json, 'require_to_upload') ? undefined : json['require_to_upload'],
        'nonUserEditable': !exists(json, 'non_user_editable') ? undefined : json['non_user_editable'],
        'validation': !exists(json, 'validation') ? undefined : json['validation'],
        'regex': !exists(json, 'regex') ? undefined : json['regex'],
        'rangeMin': !exists(json, 'range_min') ? undefined : json['range_min'],
        'rangeMax': !exists(json, 'range_max') ? undefined : json['range_max'],
        'numberOfDigits': !exists(json, 'number_of_digits') ? undefined : json['number_of_digits'],
        'metadataPrefill': !exists(json, 'metadata_prefill') ? undefined : json['metadata_prefill'],
        'highlightExpiration': !exists(json, 'highlight_expiration') ? undefined : json['highlight_expiration'],
        'multipleResponse': !exists(json, 'multiple_response') ? undefined : json['multiple_response'],
        'helpText': !exists(json, 'help_text') ? undefined : json['help_text'],
    };
}

export function CustomFieldToJSON(value?: CustomField | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'labels': value.labels,
        'options': value.options,
        'name': value.name,
        'order': value.order,
        'type': value.type,
        'use_for_uploads': value.useForUploads,
        'require_to_upload': value.requireToUpload,
        'non_user_editable': value.nonUserEditable,
        'validation': value.validation,
        'regex': value.regex,
        'range_min': value.rangeMin,
        'range_max': value.rangeMax,
        'number_of_digits': value.numberOfDigits,
        'metadata_prefill': value.metadataPrefill,
        'highlight_expiration': value.highlightExpiration,
        'multiple_response': value.multipleResponse,
        'help_text': value.helpText,
    };
}


